import axios from "axios"
import store from "@/store"
import dynamodb from "aws-sdk/clients/dynamodb"


// this is the normal data api
var request = axios.create({
  baseURL:
    window.location.hostname == "localhost"
      ? "https://g9kje7m1v9.execute-api.eu-west-2.amazonaws.com/live" // "https://vmsmf60udl.execute-api.eu-west-2.amazonaws.com/live/"
      : "https://g9kje7m1v9.execute-api.eu-west-2.amazonaws.com/live", //"https://vmsmf60udl.execute-api.eu-west-2.amazonaws.com/live/",
  headers: { "Content-Type": "application/json" }
})


// this is the PDF api
var AWS = axios.create({
  baseURL:
    window.location.hostname == "localhost"
      ? "https://mqdpa17wz4.execute-api.eu-west-2.amazonaws.com/prod" //"https://6se5itkscc.execute-api.eu-west-2.amazonaws.com/prod/"
      : "https://mqdpa17wz4.execute-api.eu-west-2.amazonaws.com/prod" //"https://6se5itkscc.execute-api.eu-west-2.amazonaws.com/prod/"
})

export default {
  getPages: function(type, limit = "", filter = "", attributes = "", order = "") {
    return new Promise((resolve, reject) => {
      request
        .get(
          "getitems?siteid=" +
            store.state.site_id +
            "&itemtype=" +
            type +
            "&attr=ItemID,name,url,hide" +
            (attributes ? "," + attributes : "") +
            (limit ? "&limit=" + limit : "") +
            (filter ? "&filter=" + filter : "") +
            (order ? "&orderby=" + order : "")
        )
        .then(response => {
          resolve(response.data.Items.map(item => dynamodb.Converter.unmarshall(item)).filter(page => !page.hide))
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getPagesPOST: function(
    ItemType,
    ExpressionAttributeValues = "",
    ExpressionAttributeNames = "",
    FilterExpression = "",
    ProjectionExpression = "",
    ScanIndexForward = true
  ) {
    return new Promise((resolve, reject) => {
      var params = {
        TableName: "cms",
        IndexName: "SiteID-ItemType-index",
        KeyConditionExpression: "SiteID = :siteid and begins_with ( ItemType, :itemtype )",
        ExpressionAttributeNames: Object.assign(
          {
            "#ItemID": "ItemID",
            "#name": "name",
            "#url": "url",
            "#hide": "hide",
            "#active": "active"
          },
          ExpressionAttributeNames
        ),
        ExpressionAttributeValues: Object.assign(
          {
            ":siteid": dynamodb.Converter.input(store.state.site_id),
            ":itemtype": dynamodb.Converter.input(ItemType + "="),
            ":true": dynamodb.Converter.input(true),
            ":false": dynamodb.Converter.input(false)
          },
          ExpressionAttributeValues
        ),
        FilterExpression:
          "#active = :true and (#hide = :false or attribute_not_exists(#hide))" +
          (FilterExpression ? " and " + FilterExpression : ""),
        ProjectionExpression: "#ItemID, #name, #url, #hide" + (ProjectionExpression ? "," + ProjectionExpression : "")
      }

      if (ProjectionExpression == "*") {
        delete params.ProjectionExpression
        params.ExpressionAttributeNames = Object.assign(
          { "#hide": "hide", "#active": "active" },
          ExpressionAttributeNames
        )
      }

      if (!ScanIndexForward) params.ScanIndexForward = false

      recursivelyQuery("getitems?siteid=" + store.state.site_id, params)
        .then(response => {
          resolve(response.map(item => dynamodb.Converter.unmarshall(item)))
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getPageByURL: function(url, routename) {
    return new Promise((resolve, reject) => {
      request
        .get("getpage?siteid=" + store.state.site_id + "&url=" + url.replace("project/", ""))
        .then(response => {
          var page = dynamodb.Converter.unmarshall(response.data.Items[0])
          if (routename == "admin-product-to-pdf") {
            request
              .get("getitem?siteid=" + store.state.site_id + "&itemid=" + page.ItemID + ":page.livepdfproducts")
              .then(response2 => {
                if (response2.data.Item) {
                  var pdfpage = dynamodb.Converter.unmarshall(response2.data.Item)
                  resolve(pdfpage)
                } else {
                  request
                    .get("getitem?siteid=" + store.state.site_id + "&itemid=" + page.ItemID + ":page.pdfproducts")
                    .then(response2 => {
                      if (response2.data.Item) {
                        var pdfpage = dynamodb.Converter.unmarshall(response2.data.Item)
                        resolve(pdfpage)
                      } else resolve(page)
                    })
                    .catch(error => {
                      reject(error)
                    })
                }
              })
              .catch(error => {
                reject(error)
              })
          } else resolve(page)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getPageByItemID: function(itemid, attr = "") {
    return new Promise((resolve, reject) => {
      request
        .get("getitem?siteid=" + store.state.site_id + "&itemid=" + itemid + (attr ? "&attr=" + attr : ""))
        .then(response => resolve(dynamodb.Converter.unmarshall(response.data.Item)))
        .catch(error => {
          reject(error)
        })
    })
  },
  sendEmail: function(subject, content) {
    return new Promise((resolve, reject) => {
      request
        .post(
          "submit?siteid=" + store.state.site_id,
          JSON.stringify({
            personalizations: [
              {
                to: [
                  {
                    email: "enquiries@southgatelighting.com"
                  }
                ],
                subject: subject
              }
            ],
            from: {
              email: "southgate@danfrench.net"
            },
            content: [
              {
                type: "text/html",
                value: content
              }
            ]
          })
        )
        .then(response => {
          console.log(response)
          resolve()
        })
        .catch(error => {
          console.error(error)
          reject(error)
        })
    })
  },
  getPDF: function(data) {
    return new Promise((resolve, reject) => {
      AWS.post("southgate-pdf", data)
        .then(res => {
          resolve(res)
        })
        .catch(() => {
          AWS.post("southgate-pdf", data)
            .post("southgate-pdf", data)
            .then(res => {
              resolve(res)
            })
            .catch(() => {
              AWS.post("southgate-pdf", data)
                .post("southgate-pdf", data)
                .then(res => {
                  resolve(res)
                })
                .catch(error => {
                  reject(error)
                })
            })
        })
    })
  },
  getAdminPDF: function(data) {
    return new Promise((resolve, reject) => {
      AWS.post("southgate-admin-pdf", data)
        .then(res => {
          resolve(res)
        })
        .catch(() => {
          AWS.post("southgate-admin-pdf", data)
            .then(res => {
              resolve(res)
            })
            .catch(() => {
              AWS.post("southgate-admin-pdf", data)
                .then(res => {
                  resolve(res)
                })
                .catch(error => {
                  reject(error)
                })
            })
        })
    })
  }
}

function recursivelyQuery(url, params, LastEvaluatedKey = null, Items = []) {
  delete params.ExclusiveStartKey
  if (LastEvaluatedKey) params.ExclusiveStartKey = LastEvaluatedKey

  return singleQuery(url, params).then(function(response) {
    Items = Items.concat(response.data.Items)

    if (response.data.LastEvaluatedKey) {
      return recursivelyQuery(url, params, response.data.LastEvaluatedKey, Items)
    } else {
      return Items
    }
  })
}

function singleQuery(url, params) {
  return new Promise((resolve, reject) => {
    request
      .post(url, params)
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  })
}
